import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/home/index'
import awardList from '@/pages/home/awardList'
import clear from '@/pages/home/clear'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        index: 0,
        title: '猪年砸金猪'
      }
    },
    {
      path: '/home/awardList',
      name: 'awardList',
      component: awardList,
      meta: {
        index: 1,
        title: '中奖记录'
      }
    },
    {
      path: '/home/clear',
      name: 'clear',
      component: clear,
      meta: {
        index: 1,
        title: '清除'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js